import { Linking } from 'react-native'

export const openWhatsApp = (whatsAppText, whatsAppNumber) => {
  Linking.canOpenURL(`whatsapp://send?text=${whatsAppText}&phone=${whatsAppNumber}`).then(supported => {
    if (supported) {
      return Linking.openURL(`whatsapp://send?text=${whatsAppText}&phone=${whatsAppNumber}`)
    } else {
      return Linking.openURL('market://details?id=com.whatsapp')
    }
  })
}
